/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type SignInMethodFieldQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type SignInMethodFieldQuery = {
  __typename?: 'Query'
  backofficeOrganizations: Array<{
    __typename?: 'BackofficeOrganization'
    id: string
    cognitoIdentityProviderName: string | null
  }>
}

export const SignInMethodFieldDocument = gql`
    query SignInMethodField {
  backofficeOrganizations {
    id
    cognitoIdentityProviderName
  }
}
    `

/**
 * __useSignInMethodFieldQuery__
 *
 * To run a query within a React component, call `useSignInMethodFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignInMethodFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignInMethodFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignInMethodFieldQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SignInMethodFieldQuery,
    SignInMethodFieldQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SignInMethodFieldQuery,
    SignInMethodFieldQueryVariables
  >(SignInMethodFieldDocument, options)
}
export function useSignInMethodFieldLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SignInMethodFieldQuery,
    SignInMethodFieldQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SignInMethodFieldQuery,
    SignInMethodFieldQueryVariables
  >(SignInMethodFieldDocument, options)
}
export function useSignInMethodFieldSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SignInMethodFieldQuery,
        SignInMethodFieldQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SignInMethodFieldQuery,
    SignInMethodFieldQueryVariables
  >(SignInMethodFieldDocument, options)
}
export type SignInMethodFieldQueryHookResult = ReturnType<
  typeof useSignInMethodFieldQuery
>
export type SignInMethodFieldLazyQueryHookResult = ReturnType<
  typeof useSignInMethodFieldLazyQuery
>
export type SignInMethodFieldSuspenseQueryHookResult = ReturnType<
  typeof useSignInMethodFieldSuspenseQuery
>
export type SignInMethodFieldQueryResult = Apollo.QueryResult<
  SignInMethodFieldQuery,
  SignInMethodFieldQueryVariables
>
